// extracted by mini-css-extract-plugin
module.exports = {"modal":"ModalAnswers_modal__K86eW","modal__content":"ModalAnswers_modal__content__2Hx1y"};